import KeyOption from "../interfaces/KeyOption.interface";
import data from "../consts/data.json";

export const sortArrayByKeyOrderOrRandom = (
  array: KeyOption[],
  random = false
) => {
  const sortedArray = array.slice();
  if (random) {
    sortedArray.sort(() => Math.random() - 0.5);
  } else {
    sortedArray.sort(
      (a, b) =>
        data.orderOfKeys.indexOf(a.value) - data.orderOfKeys.indexOf(b.value)
    );
  }

  return sortedArray;
};

export const validateSelection = (
  selectedOption: string,
  questionValue: string
): boolean => {
  return selectedOption === questionValue;
};
